import src from "IMAGE";
export default { src, width: 16, height: 16, blurWidth: 0, blurHeight: 0};
